import React, { useCallback, useMemo } from 'react';
import RowSubComponent from '../RowSubComponent';
import TableAdvanced from '../../../../../../components/TableAdvanced';
import IconWrap from '../../../../../../components/IconWrap';
import Icon from '../../../../../../components/Icon';
import Place from '../../../../../../components/Place';
import { format, fromUnixTime } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const ReportsTable = ({ onClickDelete, reports }) => {
    const { t } = useTranslation()
    const { currency } = useSelector((state) => state.currency);

    const columns = useMemo(() => [
        {
            Header: t('Data raportu'),
            accessor: 'date_place',
            Cell: ({ cell: { value } }) => {
                return (
                    <Place
                        name={format(fromUnixTime(value?.date), 'dd.MM.yyyy, HH:mm')}
                        logo={{ url: value?.place }}
                    />
                );
            }
        },
        {
            Header: t('Nazwa raportu'),
            accessor: 'name'
        },
        {
            Header: t('Data świadczenia pracy'),
            accessor: 'date_work',
            Cell: ({ cell: { value } }) => format(fromUnixTime(value), 'dd.MM.yyyy, HH:mm')
        },
        {
            Header: t('Liczba roboczogodzin'),
            accessor: 'work_days'
        },
        {
            Header: t('Średnia ocena'),
            accessor: 'rating'
        },
        {
            Header: t('Koszt brutto'),
            accessor: 'cost',
            Cell: ({ cell: { value } }) => `${value} ${currency}`,
        },
        {
            Header: () => null,
            id: 'expander',
            disableResizing: true,
            Cell: ({ row }) => (
                <IconWrap rotate={row.isExpanded ? 0 : -180} align="right">
                    <Icon name="arrow" />
                </IconWrap>
            ),
            width: 30
        },
    ], [t, currency]);

    const renderRowSubComponent = useCallback(({ row }) => (
        <RowSubComponent
            row={row}
            onClickDelete={onClickDelete}
        />
    ), [onClickDelete]);

    return (
        <>
            <TableAdvanced
                columns={columns}
                data={reports}
                renderRowSubComponent={renderRowSubComponent}
            />
        </>
    )
};

export default ReportsTable;
